import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import { MemberImportCsvPreviewComponent } from '../tables/bulk-member-import-table/member-import-csv-preview.component';

@Component({
    selector: 'ca-member-import',
    templateUrl: 'member-import.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MemberImportComponent {
  @ViewChild('fileInput', { static: true }) fileInput;
  @ViewChild(MemberImportCsvPreviewComponent) csvPreview: MemberImportCsvPreviewComponent;
  @Input() config;
  @Output() import = new EventEmitter<any>();

  loading$: Observable<boolean>;
  results$: Observable<any[]>;
  error$: Observable<any>;
  file: File;

  constructor(public store: Store<any>) {
    this.store.dispatch(actions.BulkReset);
    this.loading$ = this.store.select(selectors.bulk.getLoading);
    this.results$ = this.store.select(selectors.bulk.getResults);
    this.error$ = this.store.select(selectors.bulk.getResults);
  }

  submit() {
    if (this.csvPreview.valid) {
      const payload = this.csvPreview.value.rows;
      this.import.emit(payload);
    }
  }

  changed() {
    this.file = this.fileInput.nativeElement.files[0];
    this.fileInput.nativeElement.value = ''; // Clear so the same file can be chosen agian;
  }
}
